import React from 'react';
import { Link } from 'gatsby';
import { navigate } from 'gatsby-link';
import { AppContextType, withAppContext } from 'context/AppContext';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { SliceContext } from 'components/Slices/types';
import { getSanitizedURL } from 'helpers/getSanitizedURL';

export type InternalLinkProps = {
    label?: string | null;
    link: {
        url: string;
        raw?: {
            target: '_blank' | null;
        };
    };
    className?: string;
    children?: any;
    slice?: SliceContext;
    context?: AppContextType;
};

export const InternalLinkComponent = (props: InternalLinkProps) => {
    /**
     * Redirects the user to the target href and adds any existing query parameters.
     * @param {React.MouseEvent<HTMLAnchorElement>} event : the click event
     */
    const followLink = (event: React.MouseEvent<HTMLAnchorElement>): void => {
        event.preventDefault();

        const url = event.currentTarget.getAttribute('href') || '';
        const segment = props.context && props.context.segment;

        if (segment) {
            segment.trackLinkFollowed({ 'L - Destination Link': url }, props.slice);
        }

        navigate(url);
    };

    const { label, link, className, children } = props;
    const url = getSanitizedURL(link.url);

    return (
        <Link to={url} className={className} activeClassName="is-active" onClick={followLink}>
            {label ? <PrismicHTMLParser>{label}</PrismicHTMLParser> : children}
        </Link>
    );
};

export const InternalLink = withAppContext(InternalLinkComponent);
